import { render, staticRenderFns } from "./ChartHorizontal.vue?vue&type=template&id=266a9005&"
import script from "./ChartHorizontal.vue?vue&type=script&lang=js&"
export * from "./ChartHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports